import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class personalinformation {
  StudentID:number;
  RegFormNo:number;
  StudentTitle:string;
  StudentName:string;
  StudentFirstName:string;
  StudentLastName:string;
  StudentMiddleName:string;
  StudentMothersName:string;
  StudentSexCode:string;
  StudentBirthDate:string;
  StudentUIDNo:string;
  StudentReligionID:number;
  StudentCastID:number;
  StudentSubCastID:number;
  PRNNO:string;
  StudentCategoryID:number;
  SpecialConsidertionID:number;
  ReservationCategoryID:number;
  ConsessionID:number;
  GuardianOccupationID:number;
  MaritalStatusFlag:string;
  NationalityFlag:string;
  StudentPassPortNo:string;
  StudentPhone:string;
  StudentMobileNo:string;
  GuardianPhoneNo:string;
  StudentDrivingLicenceNo:string;
  StudentBloodGroup:string;
  StudentMailID:string;
  StudentSecondMailID:string;
  ReligionOtherDetl:string;
  AadharNoID:string;
  AadharName:string;
  SubCasteOtherDetl:string;
  PhysicalDisabilityID:number;
  UrbanRuralTypeID:number;
  OtherPRN:string;
  AnnualIncome:number;
  StudentNameBL:string;
  StudentMothersNameBL:string;
  TwoSemDataFlag:string;
  VoteReg:string;
  VoterID:string;
  BankName:string;
  BankBranchName:string;
  AccountNo:string;
  IFSCcode:string;
  PANCardNo:string;
  Migrated:string;
  StudentTypesmall:number;
  IdentiMark1:string;
  IdentiMark2:string;
  PreviousNameOfStudent:string;
  ReasonOfNameChange:string;
  MotherToung:string;
  EmploymentStatus:string;
  HobbyID:string;
  SportsID:string;
  ReservationID:string;
  JoinNssNcc:string;
  OrganDonor:string;
  VisaNumber:string;
  VisaValidity:string;
  DeleteFlag:string;
  CreatedDate:string;
  CreatedLoginID:number;
  UpdatedDate:string;
  UpdatedLoginID:number;
  age:number;
  ConfirmStudent:string;
  CourseTypeID:number;
  SocialReservationID:number;
  ProfileLockStatusFlag:string;
  CourseID:number;
}
export class personalinformation2 {
  
  StudentID:number;
  StudentReligionID:number;
  StudentCastID:number;
  StudentSubCastID:number;
  PRNNO:string;
  StudentCategoryID:number;
  SpecialConsidertionID:number;
  ReservationCategoryID:number;
  ConsessionID:number;
  GuardianOccupationID:number;
  MaritalStatusFlag:string;
  NationalityFlag:string;
  StudentPassPortNo:string;
  StudentPhone:string;
  StudentMobileNo:string;
  GuardianPhoneNo:string;
  StudentDrivingLicenceNo:string;
  StudentBloodGroup:string;
  StudentMailID:string;
  StudentSecondMailID:string;
  ReligionOtherDetl:string;
  AadharNoID:string;
  AadharName:string;
  SubCasteOtherDetl:string;
  PhysicalDisabilityID:number;
  UrbanRuralTypeID:number;
  OtherPRN:string;
  AnnualIncome:number;
  StudentNameBL:string;
  StudentMothersNameBL:string;
  TwoSemDataFlag:string;
  VoteReg:string;
  VoterID:string;
  BankName:string;
  BankBranchName:string;
  AccountNo:string;
  IFSCcode:string;
  PANCardNo:string;
  Migrated:string;
  StudentTypesmall:number;
  IdentiMark1:string;
  IdentiMark2:string;
  PreviousNameOfStudent:string;
  ReasonOfNameChange:string;
  MotherToung:string;
  EmploymentStatus:string;
  HobbyID:string;
  SportsID:string;
  ReservationID:string;
  JoinNssNcc:string;
  OrganDonor:string;
  VisaNumber:string;
  VisaValidity:string;
  DeleteFlag:string;
  CreatedDate:string;
  CreatedLoginID:number;
  UpdatedDate:string;
  UpdatedLoginID:number;
  age:number;
  SubCasteID:number;
  Gender:string;

  RegFormNo:number;
  StudentTitle:string;
  StudentName:string;
  StudentFirstName:string;
  StudentLastName:string;
  StudentMiddleName:string;
  StudentMothersName:string;
  StudentSexCode:string;
  StudentBirthDate:string;
  StudentUIDNo:string;
  BloodGroupID:string;
  StudYear:number;

  FatherTitle:string;
  FatherFirstName:string;
  FatherMiddleName:string;
  FatherLastName:string;
  MotherTitle:string;
  MotherFirstName:string;
  MotherMiddleName:string;
  MotherLastName:string;

  RegisteredForVoter:boolean;
  MinorityTypeID:number;
  MinorityID:number;
  OtherCasteName:string;
  StudentRegType:string;
  PhysicalDisabilityPercent:number;


  ReligionDescription:string;
  CasteDescription:string;
  GuardianOccupationName:string;
  ReservationCategoryName:string;
  PhysicalDisabilityName:string;
  MinorityDescription:string;
  ConfirmStudent:string;

  BirthCountry:string;
  BirthState:string;
  BirthDistrict:string;
  BirthThasil:string;
  BirthPlace:string;

  StudentType:string;
  SocialReservationID:string;
  CourseTypeID:number;
  OtherCaste: string;

  CourseID:number;
  ABCID:number;

  MinorityCheck: string;
  ScholarshipApplicable: string;
}
export class Occupations {
  GuardianOccupationID:number;
  GuardianOccupationName:string;
}
export class MinorityDataList {
  MinorityID:number;
  MinorityDescription:string;
  MinorityType:string;
  MinorityCode:string;
}
export class PreviousCollegeList {
  UniversityTypeId:number;
  UniversityTypeName:string; 
}
export class EnrolmentSubjectMain{
  AcademicInstanceID:number;
  ExamInstanceID:number;
  StudentID:number;
  CollegeID:number;
  CourseID:number;
  BranchID:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  EnrolmentSubject:EnrolmentSubject[];

  EntSubjectID :number;
  OutOfMark:number;
  ObtMark:number;
  Percentage :number;
}
export class EnrolmentSubject{
  EntEnrolmentSubjectID:number;
  CoursePartID:number;
  BranchID:number;
  SyllabusID:number;
  SubjectID:number;
  CategoryID:number;
  PaperID:number;
  SectionID:number;
  ExamCentreCollegeID:number;
  FreshRepeaterFlag:boolean;
  SubjectStatusFlag:boolean;
  SubjectUniversityCode:string;
  CoursePartDescription:string;
  CoursePartShortName:string;
  SubjectName:string;
  PartSeq:string;
  MaxNoOfSubjects:number;
  MinNoOfSubjects:number;
  SyllabusGroupName:string;
  GroupMaxItem:number;
  GroupMinimumItem:number;
  GroupOrSubjectFlag:string;
  GroupCompulsaryFlag:string;
  SubjectCompulsoryOptionalFlag:string;
  SyllabusGroupID:number;
  IsChecked:boolean;
  IsDisabled:boolean;
  rowId:number;
  Appear:string;
  SyllabusGroupName1:string;
  GroupCompulsaryFlag1:string;
  MainSyllabusGroupID:number;
  MainGroupFlag:string;

  EntSubjectID :number;
  StudentID:number;
  OutOfMark:number;
  ObtMark:number;
  Percentage :number;
}

@Injectable({
  providedIn: 'root'
})
@Component({
  providers: [DataAccessService]
})

export class PersonalinformationService {  

  constructor(private dataService: DataAccessService) { }
  public PersonalinformationData: PersonalinformationService;


  public GetPortalStudentLogInList(StuPoartlaID) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetPortalStudentLogInList?StuPoartlaID='+ StuPoartlaID + ""; // setting method name from API controller.
    return this.dataService.getAll<personalinformation[]>()
  } 
  public GetPortalStudentLogInListForm2(StuPoartlaID) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetPortalStudentLogInList?StuPoartlaID='+ StuPoartlaID + ""; // setting method name from API controller.
    return this.dataService.getAll<personalinformation2[]>()
  } 
  public GetPortalStudentLogInListInsertPreStudentInformation(StuPoartlaID) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetPortalStudentLogInListInsertPreStudentInformation?StuPoartlaID='+ StuPoartlaID + ""; // setting method name from API controller.
    return this.dataService.getAll<personalinformation2[]>()
  } 
  public GetPersonalInformation(StudentID,ProfileLockStatusFlag) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByIDForPortal?StudentID='+ StudentID + '&ProfileLockStatusFlag=' + ProfileLockStatusFlag + '' ;
    return this.dataService.getAll<personalinformation[]>()
  }
  public GetPreStudentInformationListByIDForPortalNEW(StudentID,ProfileLockStatusFlag) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByIDForPortal?StudentID='+ StudentID + '&ProfileLockStatusFlag=' + ProfileLockStatusFlag + '' ;
    return this.dataService.getAll<personalinformation[]>()
  }
  public GetSyllabusSubjectsForPortal(CourseID,BranchID,CollegeID,StudentID,AcademicInstanceID) {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetSyllabusSubjectsForPortal?CourseID='+ CourseID + '&BranchID=' + BranchID + '&CollegeID='+ CollegeID+ '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID+'' ;
    return this.dataService.getAll<EnrolmentSubject[]>()
  } 
  public GetSyllabusSubjectsForPortalMarks(CourseID,BranchID,CollegeID,StudentID,AcademicInstanceID) {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetSyllabusSubjectsForPortalMarks?CourseID='+ CourseID + '&BranchID=' + BranchID + '&CollegeID='+ CollegeID+ '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID+'' ;
    return this.dataService.getAll<EnrolmentSubject[]>()
  }
  public GetSyllabusSubjectsForPortalForEnrolmentByBranch(CourseID,BranchID,CollegeID,StudentID,AcademicInstanceID,CoursePartID) {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetSyllabusSubjectsForPortalForEnrolmentByBranch?CourseID='+ CourseID + '&BranchID=' + BranchID + '&CollegeID='+ CollegeID+ '&StudentID=' + StudentID + '&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID=' + CoursePartID + '' ;
    return this.dataService.getAll<EnrolmentSubject[]>()
  } 
/* public MinorityDescriptionWithType(){
  this.dataService.setControllerName = '/BasicCountry/';
  this.dataService.setMethodName = 'MinorityDescriptionWithType'
  return this.dataService.getAll<personalinformation[]>()
} */
  public save(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostInsertPreStudentInformation'; // setting method name from API controller.
    return this.dataService.add<personalinformation[]>(data) 
  }
  public saveProfile1(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostInsertPreStudentInformationProfile1'; // setting method name from API controller.
    return this.dataService.add<personalinformation[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostPreStudentInformation'; // setting method name from API controller.
    return this.dataService.add<personalinformation[]>(data)
  }
  public updateProfile1(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostPreStudentInformationProfile1'; // setting method name from API controller.
    return this.dataService.add<personalinformation[]>(data)
  }
  public PostInsertEntSubject(data) {debugger
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'PostInsertEntPreEnrollSubjects'; // setting method name from API controller.
    return this.dataService.add<EnrolmentSubjectMain[]>(data) 
  }
  public PostInsertEntSubjectMarks(data) {debugger
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'PostInsertEntPreEnrollSubjectsMarks'; // setting method name from API controller.
    return this.dataService.add<EnrolmentSubjectMain[]>(data) 
  }
  public getStudentID(StuPoartlaID) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetPortalStudentLogInList?StuPoartlaID=' + StuPoartlaID + ''; // setting method name from API controller.
    return this.dataService.getAll<personalinformation[]>()
  }
  public GetGardianOccupation() {
    this.dataService.setControllerName = '/BasicGuardianOccupations/';
    this.dataService.setMethodName = 'GetBasicGuardianOccupationsList?GuardianOccupationID=0'; 
    return this.dataService.getAll<Occupations[]>()
  } 
  public GetAllMinorityList() {
    this.dataService.setControllerName = '/BasicMinority/';
    this.dataService.setMethodName = 'GetReservationCatAsAminority?MinorityID=0'; 
    return this.dataService.getAll<MinorityDataList[]>() ///GetReservationCatAsAminority
  } 

  public GetStudentUniversityType() {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetStudentUniversityType'; 
    return this.dataService.getAll<PreviousCollegeList[]>()
  } 



  // FOR STUDENT PORTAL

  public GetPortalStudentLogInListForStudentProfile(StuPoartlaID) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetPortalStudentLogInListForStudentProfile?StuPoartlaID='+ StuPoartlaID + ""; // setting method name from API controller.
    return this.dataService.getAll<personalinformation2[]>()
  } 

  
  public PostInsertStudentProfile(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostInsertStudentProfile';
    return this.dataService.add<personalinformation[]>(data)
  }



  public saveStudentProfile(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostInsertPreStudentInformationForStudentProfile'; // setting method name from API controller.
    return this.dataService.add<personalinformation[]>(data) 
  }


  public updateStudentProfile(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostPreStudentInformationForStudentProfile'; // setting method name from API controller.
    return this.dataService.add<personalinformation[]>(data)
  }
}
// function data<T>(data: any) {
//   throw new Error('Function not implemented.');
// }

